import Store from 'App/babel/store';

export default function ListFormsAllowed() {
	const state = Store.getState();
	const self = state.App.self;
	const features = state.App.accountSelf?.features;
	return features?.forms && (self?.administrator || self?.userParams.mailAdmin);
}
